import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import Login from "../Login/Login.jsx";
import ForgotPassword from "../Login/ForgotPassword.jsx";
import ResetPassword from "../Login/ResetPassword.jsx";

// Rutas para administradores

import Dashboard from "../Admin/Dashboard.jsx";
import ProtectedRoute from "../utils/ProtectedRoute.jsx";
import AdminUsers from "../Admin/Administration/AdminUsers.jsx";
import AdminApartments from "../Admin/Administration/AdminApartments.jsx";
import AdminPets from "../Admin/Administration/AdminPets.jsx";
import AdminTowers from "../Admin/Administration/AdminTowers.jsx";
import AdminVehicles from "../Admin/Administration/AdminVehicles.jsx";
import ControlVehicles from "../Admin/Administration/AdminVehicles/ControlVehicles.jsx";
import AdminParkings from "../Admin/Administration/AdminParkings.jsx";
import ControlParkings from "../Admin/Administration/AdminParkings/ControlParkings.jsx";
import ControlExternalParkings from "../Admin/Administration/AdminParkings/ControlExternalParkings.jsx";
import AdminVisitorParking from "../Admin/Administration/AdminVisitorParking.jsx";
import ControlPets from "../Admin/Administration/AdminPets/ControlPets.jsx";
import VisitReport from "../Admin/Reports/Visit/VisitReport.jsx";
import ShipmentReport from "../Admin/Reports/Shipment/ShipmentReport.jsx";
import TowerShipmentReport from "../Admin/Reports/Shipment/TowerShipmentReport.jsx";
import AdminInquilinos from "../Admin/Administration/AdminUsers/AdminInquilinos.jsx";
import ControlInquilinos from "../Admin/Administration/AdminUsers/ControlInquilinos.jsx";
import AdminAdministrators from "../Admin/Administration/AdminAdmins/AdminAdministrators.jsx";
import AdminSecurity from "../Admin/Administration/AdminSecurity/AdminUserSecurity.jsx";
import ControlApartments from "../Admin/Administration/AdminApartments/ControlApartments.jsx";
import TowerPackages from "../Admin/Reports/Shipment/TowerPackages.jsx";
import TowerVisit from "../Admin/Reports/Visit/TowerVisit.jsx";
import AdminPool from "../Admin/Administration/AdminPool.jsx";
import AdminSalon from "../Admin/Administration/AdminSalon.jsx";
import AdminComunicados from "../Admin/Administration/AdminComunicados.jsx";
import AdminNotificaciones from "../Admin/AdminNotificaciones.jsx";

// Rutas para seguridad

import IndexSecurity from "../Security/IndexSecurity.jsx";
import VisitControl from "../Security/VisitControl/VisitControl.jsx";
import PackageControl from "../Security/PackageControl/PackageControl.jsx";
import ParkingControl from "../Security/ParkingControl/ParkingControl.jsx";
import SecurityVehicleControl from "../Security/VehicleControl/SecurityVehicleControl.jsx";
import SecurityRequests from "../Security/Requests/SecurityRequests.jsx";
import ComunicadosSecurity from "../Security/ComunicadosSecurity.jsx";
import SecurityNotificaciones from "../Security/SecurityNotificaciones.jsx";

// Rutas para inquilinos

import VisitsControl from "../Inquilinos/VisitControl/VisitsControl.jsx";
import PackagesControl from "../Inquilinos/PackageControl/PackagesControl.jsx";
import OrdersControl from "../Inquilinos/OrdersControl/OrdersControl.jsx";
import UserVehicles from "../Inquilinos/VehicleControl/UserVehicles.jsx";
import UserPets from "../Inquilinos/PetControl/UserPets.jsx";
import IndexUser from "../Inquilinos/IndexUser.jsx";
import ShipmentsUsrReport from "../Inquilinos/Reports/ShipmentsUsrReport.jsx";
import VisitsUsrReport from "../Inquilinos/Reports/VisitsUsrReport.jsx";
import ComunicadosUser from "../Inquilinos/ComunicadosUser.jsx";
import UserNotificaciones from "../Inquilinos/UserNotificaciones.jsx";
import UserEmergencias from "../Inquilinos/UserEmergencias.jsx";
import UserRecurringVisitors from "../Inquilinos/RecurringVisitors/UserRecurringVisitors.jsx";
import AdminRecurringVisitors from "../Admin/Administration/AdminRecurringVisitors.jsx";
import AdminCartera from "../Admin/Administration/AdminCartera.jsx";
import ControlCartera from "../Admin/Administration/AdminCartera/ControlCartera.jsx";
import SecurityEmergencias from "../Security/SecurityEmergencias.jsx";
import AdminEmergencias from "../Admin/AdminEmergencias.jsx";
import AdminWhatsapp from "../Admin/AdminWhatsapp.jsx";

// Ruta compartida

import Profile from "../Profile/Profile.jsx";
import PWAInstallBanner from "../common/PWAInstallBanner.jsx";

const Main = () => {
  return (
    
    <BrowserRouter>
      <PWAInstallBanner />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/resetPassword/:token" element={<ResetPassword />} />

        {/* RUTAS PROTEGIDAS PARA ADMINISTRADORES */}
        <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} allowedRoles={[1]} />} />
        <Route path="/adminUsers" element={<ProtectedRoute element={<AdminUsers />} allowedRoles={[1]} />} />
        <Route path="/adminAdministrators" element={<ProtectedRoute element={<AdminAdministrators />} allowedRoles={[1]} />} />
        <Route path="/adminSecurity" element={<ProtectedRoute element={<AdminSecurity />} allowedRoles={[1]} />} />
        <Route path="/adminInquilinos" element={<ProtectedRoute element={<AdminInquilinos />} allowedRoles={[1]} />} />
        <Route path="/controlInquilinos/:id_torre" element={<ProtectedRoute element={<ControlInquilinos />} allowedRoles={[1]} />} />
        <Route path="/adminApartments" element={<ProtectedRoute element={<AdminApartments />} allowedRoles={[1]} />} />
        <Route path="/controlApartments/:id_torre" element={<ProtectedRoute element={<ControlApartments />} allowedRoles={[1]} />} />
        <Route path="/adminTowers" element={<ProtectedRoute element={<AdminTowers />} allowedRoles={[1]} />} />
        <Route path="/adminPets" element={<ProtectedRoute element={<AdminPets />} allowedRoles={[1]} />} />
        <Route path="/controlPets/:id_torre" element={<ProtectedRoute element={<ControlPets />} allowedRoles={[1]} />} />
        <Route path="/adminVehicles" element={<ProtectedRoute element={<AdminVehicles />} allowedRoles={[1]} />} />
        <Route path="/controlVehicles/:id_torre" element={<ProtectedRoute element={<ControlVehicles />} allowedRoles={[1]} />} />
        <Route path="/adminParkings" element={<ProtectedRoute element={<AdminParkings />} allowedRoles={[1]} />} />
        <Route path="/controlParkings/:id_torre" element={<ProtectedRoute element={<ControlParkings />} allowedRoles={[1]} />} />
        <Route path="/controlExternalParkings" element={<ProtectedRoute element={<ControlExternalParkings />} allowedRoles={[1]} />} />
        <Route path="/adminVisitorParking" element={<ProtectedRoute element={<AdminVisitorParking />} allowedRoles={[1]} />} />
        <Route path="/visitReport" element={<ProtectedRoute element={<VisitReport />} allowedRoles={[1]} />} />
        <Route path="/shipmentReport" element={<ProtectedRoute element={<ShipmentReport />} allowedRoles={[1]} />} />
        <Route path="/towerShipmentReport/:towerId" element={<ProtectedRoute element={<TowerShipmentReport />} allowedRoles={[1]} />} />
        <Route path="/towerPackages/:id_torre" element={<ProtectedRoute element={<TowerPackages />} allowedRoles={[1]} />} />
        <Route path="/towerVisit/:id_torre" element={<ProtectedRoute element={<TowerVisit />} allowedRoles={[1]} />} />
        <Route path="/adminPool" element={<ProtectedRoute element={<AdminPool />} allowedRoles={[1]} />} />
        <Route path="/adminSalon" element={<ProtectedRoute element={<AdminSalon />} allowedRoles={[1]} />} />
        <Route path="/adminComunicados" element={<ProtectedRoute element={<AdminComunicados />} allowedRoles={[1]} />} />
        <Route path="/adminNotificaciones" element={<ProtectedRoute element={<AdminNotificaciones />} allowedRoles={[1]} />} />
        <Route path="/adminEmergencias" element={<ProtectedRoute element={<AdminEmergencias />} allowedRoles={[1]} />} />
        <Route path="/adminWhatsapp" element={<ProtectedRoute element={<AdminWhatsapp />} allowedRoles={[1]} />} />
        <Route path="/adminRecurringVisitors" element={<ProtectedRoute element={<AdminRecurringVisitors />} allowedRoles={[1]} />} />
        <Route path="/adminCartera" element={<ProtectedRoute element={<AdminCartera />} allowedRoles={[1]} />} />
        <Route path="/controlCartera/:id_torre" element={<ProtectedRoute element={<ControlCartera />} allowedRoles={[1]} />} />

        {/* RUTAS PROTEGIDAS PARA SEGURIDAD */}
        <Route path="/securityHome" element={<ProtectedRoute element={<IndexSecurity />} allowedRoles={[2]} />} />
        <Route path="/visitControl" element={<ProtectedRoute element={<VisitControl />} allowedRoles={[2]} />} />
        <Route path="/packageControl" element={<ProtectedRoute element={<PackageControl />} allowedRoles={[2]} />} />
        <Route path="/securityParking" element={<ProtectedRoute element={<ParkingControl />} allowedRoles={[2]} />} />
        <Route path="/securityVehicles" element={<ProtectedRoute element={<SecurityVehicleControl />} allowedRoles={[2]} />} />
        <Route path="/securityRequests" element={<ProtectedRoute element={<SecurityRequests />} allowedRoles={[2]} />} />
        <Route path="/securityComunicados" element={<ProtectedRoute element={<ComunicadosSecurity />} allowedRoles={[2]} />} />
        <Route path="/securityNotificaciones" element={<ProtectedRoute element={<SecurityNotificaciones />} allowedRoles={[2]} />} />
        <Route path="/securityEmergencias" element={<ProtectedRoute element={<SecurityEmergencias />} allowedRoles={[2]} />} />


        {/* RUTAS PROTEGIDAS PARA USUARIOS - INQUILINOS */}
        <Route path="/userHome" element={<ProtectedRoute element={<IndexUser />} allowedRoles={[3]} />} />
        <Route path="/VisitsControl" element={<ProtectedRoute element={<VisitsControl/>} allowedRoles={[3]} />} />
        <Route path="/PackagesControl" element={<ProtectedRoute element={<PackagesControl />} allowedRoles={[3]} />} />
        <Route path="/OrdersControl" element={<ProtectedRoute element={<OrdersControl />} allowedRoles={[3]} />} />
        <Route path="/UserVehicles" element={<ProtectedRoute element={<UserVehicles />} allowedRoles={[3]} />} />
        <Route path="/UserPets" element={<ProtectedRoute element={<UserPets />} allowedRoles={[3]} />} />
        <Route path="/ShipmentsUsrReport" element={<ProtectedRoute element={<ShipmentsUsrReport />} allowedRoles={[3]} />} />
        <Route path="/VisitsUsrReport" element={<ProtectedRoute element={<VisitsUsrReport />} allowedRoles={[3]} />} />
        <Route path="/userComunicados" element={<ProtectedRoute element={<ComunicadosUser />} allowedRoles={[3]} />} />
        <Route path="/userNotificaciones" element={<ProtectedRoute element={<UserNotificaciones />} allowedRoles={[3]} />} />
        <Route path="/userEmergencias" element={<ProtectedRoute element={<UserEmergencias />} allowedRoles={[3]} />} />
        <Route path="/userRecurringVisitors" element={<ProtectedRoute element={<UserRecurringVisitors />} allowedRoles={[3]} />} />

        {/* RUTA COMPARTIDA PARA PERFIL - Accesible por todos los roles */}
        <Route path="/profile" element={<ProtectedRoute element={<Profile />} allowedRoles={[1, 2, 3]} />} />


      </Routes>
    </BrowserRouter>
  );
};

export default Main;